import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const cateringCategoryBaseEndpoint = ENDPOINTS.CATERINGCATEGORY;

// Event API using Catering Package endpoints
export const cateringCategoryApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["cateringCategories"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCateringCategoryProductsByCatId: builder.query({
        query: (payload) => `${cateringCategoryBaseEndpoint}/${payload}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "cateringCategories" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addCateringCategoryProducts: builder.mutation({
        query: (requestData) => ({
          url: `${cateringCategoryBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "cateringCategories" }],
      }),

      updateCateringCategoryProducts: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${cateringCategoryBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "cateringCategories" }],
      }),
      deleteCateringCategoryProducts: builder.mutation({
        query: (id) => ({
          url: `${cateringCategoryBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "cateringCategories" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetCateringCategoryProductsByCatIdQuery,
  useAddCateringCategoryProductsMutation,
  useUpdateCateringCategoryProductsMutation,
  useDeleteCateringCategoryProductsMutation,
} = cateringCategoryApi;
